import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Link from 'components/UI/Link';
import { useLang } from 'utils/localisation';
import { useStateModal } from 'utils/hooks';

import * as styles from './NewsItem.module.scss';

const NewsModal = lazy(() => import('components/Modals/NewsModal'));

export default function NewsItem({ item, handlePushEvent, setDraggable, isLast }) {
  const { id, date, title, link, linkText } = item;
  const lang = useLang();
  const { modalState, showModal, hideModal } = useStateModal();
  const locales = lang === 'de' ? 'de-DE' : 'en-US';

  const getDate = () => {
    const preparedDay = new Date(date).toLocaleDateString(locales, {
      month: 'short',
      day: '2-digit',
    });
    return `${preparedDay}, ${new Date(date).getFullYear()}`;
  };

  const modalData = {
    id,
    date: getDate(),
    title,
  };

  const handleItemClick = () => {
    showModal();
    setDraggable(false);
    handlePushEvent('click_on_card', title);
  };

  const hidePopup = () => {
    hideModal();
    setDraggable(true);
  };

  return (
    <div className={styles.itemWrapper}>
      {isLast ? (
        <Link
          className={cn(styles.item, styles.link)}
          href={link}
          onClick={() => handlePushEvent('click_on_card', 'newsroom')}
        >
          <Title tag="h4" className={styles.linkTitle}>
            {title}
          </Title>
          <span className={styles.linkText}>{linkText}</span>
        </Link>
      ) : (
        <>
          <div className={styles.item} onClick={() => handleItemClick()}>
            <p className={styles.date}>{getDate()}</p>
            <Title tag="h4" className={styles.title}>
              {title}
            </Title>
          </div>
          <Suspense fallback={null}>
            <NewsModal
              isOpen={modalState.isOpen}
              closeModalCallback={hidePopup}
              handlePushEvent={handlePushEvent}
              {...modalData}
            />
          </Suspense>
        </>
      )}
    </div>
  );
}
